/**
 * Tiny global registry of "an editor currently has unsaved changes".
 *
 * Purpose: on iPad, switching to another app and returning triggers a window
 * focus event. With background refetching on, fresh server data can land on top
 * of what somebody is part-way through typing and the screen appears to reset.
 * Any form that registers here pauses focus refetching until it is saved.
 *
 * Deliberately module-level and framework free so both React Query's
 * `refetchOnWindowFocus` predicate and plain components can read it.
 */
const dirtyForms = new Set<string>();

export function markFormDirty(id: string): void {
  dirtyForms.add(id);
}

export function markFormClean(id: string): void {
  dirtyForms.delete(id);
}

export function hasUnsavedForms(): boolean {
  return dirtyForms.size > 0;
}
